<template>
    <div class="container">
        <menus></menus>
        <div class="main">
            <!-- 内容 -->
            <div class="user">
                <span>{{ $t('welcome.welcome') }}</span><span>{{ phone }}</span><span @click="signOut" style="color:#fff">{{
                    $t('welcome.signOut') }}</span>
            </div>
            <div>
                <div class="mainTitle">{{ $t('guest.face.title') }}</div>
                <div class="mainBody">
                    <p style="line-height:0.45rem;">{{ $t('guest.face.tips1') }}</p>
                    <p style="line-height:0.45rem;">{{ $t('guest.face.tips2') }}</p>
                    <img class='preview-img' width="100%" widths="1738" heights="1299"
                        links="https://oss.eventnet.cn/H5/Nissan_meeting/2024/vipCardBig1.png?v=12181742"
                        src='https://oss.eventnet.cn/H5/Nissan_meeting/2024/vipCardBig2.png?v=12181742' @click="bigImg">
                </div>
            </div>
        </div>
        <div class="back" @click="path('guest')" :style="{ 'font-size': $i18n.locale == 'jp' ? '.2rem' : '.28rem' }">
            <img width="100%" src="https://oss.eventnet.cn/H5/Nissan_meeting/2024/back.png" alt="">
        </div>
        <Photo class="img_big" :items="items" v-if="bigImg_show" @show="close" />
    </div>
</template>
<script>
import Photo from '../../components/PhotoSwipe';
import menus from "../../components/menu.vue"
export default {
    components: {
        menus,
        Photo
    },
    name: "menuView",
    data() {
        return {
            phone: localStorage.getItem("nissan2023_meeting_mobile"),
            items: [{
                src: '',
                w: 0,
                h: 0,
            },],
            bigImg_show: false,
        }
    },
    created() {
        //_hmt.push(['_trackPageview', '/guest/face']);
    },
    mounted() {
        // this.alerts3("<p style='text-align:left;'>" + this.$t('tips.tips3') + "</p>");
    },
    methods: {
        alerts3(content) {
            layer.open({
                title: [
                    this.$t('tips.tips1'),
                    'background-color: #c61533; color:#fff;'
                ],
                content: content,
                btn: this.$t('tips.tips2'),
                yes: function (index) {
                    layer.closeAll();
                }
            });
        },
        signOut() {
            localStorage.removeItem("nissan2023_meeting_uuid")
            this.$router.replace('/login');
        },
        path(path) {
            this.$router.replace('/' + path)
        },
        bigImg(el) {
            this.items[0].w = el.target.getAttribute('widths');
            this.items[0].h = el.target.getAttribute('heights');
            this.items[0].src = el.target.getAttribute('links');
            this.bigImg_show = true;
        },
        close(e) {
            this.bigImg_show = e;
        },
    }
}
</script>
<style scoped></style>


// WEBPACK FOOTER //
// src/views/guest/face.vue